import React from 'react';
import moment from 'moment';

export const categorizeApplications = (applicationString) => {
  const applicationList = applicationString?.split(',').map(Number);
  const uniqueCategories = [...new Set(applicationList)];
  const categoryMap = {
    0: 'Undergraduate',
    1: 'Graduate',
    2: 'Visiting',
  };
  return (
    uniqueCategories.map((cat) => categoryMap[cat]).join(', ') || 'Unknown'
  );
};

export const activeFuntion = (active) => (active ? 'Yes' : 'No');

export const formatFunction = (flag, bodyData) => {
  if (flag === 'date') {
    return moment(bodyData).format('MMM D');
  } else if (flag === 'dateTime') {
    return moment(bodyData).format('MMM D, YYYY h:mm A');
  } else if (flag === 'mobile') {
    return '+' + bodyData;
  } else if (flag === 'appType') {
    return categorizeApplications(bodyData);
  } else if (flag === 'link') {
    return (
      <a
        href={bodyData}
        target="blank"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: '#000',
        }}
      >
        {bodyData}
      </a>
    );
  } else if (flag === 'bolean') {
    return activeFuntion(bodyData);
  } else {
    return bodyData;
  }
};
